import Navbar from './components/Navbar';
import Hero from './components/Hero';
import RecentSection from './components/RecentSection';
import FilmsSection from './components/FilmsSection';
import FilmographySection from './components/FilmographySection';
import PhotosSection from './components/PhotosSection';
import EventsSection from './components/EventsSection';
import NewsSection from './components/NewsSection';
import GuideSection from './components/GuideSection';
import FaqSection from './components/FaqSection';
import SiteFooter from './components/SiteFooter';

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <RecentSection />
        <FilmsSection />
        <FilmographySection />
        <PhotosSection />
        <EventsSection />
        <NewsSection />
        <GuideSection />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}